import { offlineStorage } from './offlineStorage';

// Baut die Backend-URL, egal ob REACT_APP_API_URL mit oder ohne "/api" endet
export const createApiUrl = (endpoint) => {
  const cleanBaseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/+$/, '');
  const cleanEndpoint = endpoint.replace(/^\/+/, '');
  if (cleanBaseUrl.endsWith('/api')) {
    return `${cleanBaseUrl}/${cleanEndpoint.replace(/^api\//, '')}`;
  }
  return `${cleanBaseUrl}/${cleanEndpoint}`;
};

/**
 * Synchronisiert die lokale Besichtigung zum Server und liefert den Kunden-Link.
 * Das Backend gibt einen bestehenden aktiven Link zurück, mehrfaches Aufrufen ist also unkritisch.
 */
export const createInspectionShareLink = async (dealId) => {
  if (!dealId) throw new Error('Kein Deal ausgewählt');
  const token = localStorage.getItem('token');

  try {
    const savedState = await offlineStorage.loadInspectionState(dealId);
    if (savedState && savedState.roomsData) {
      const saveResponse = await fetch(createApiUrl(`api/moves/${dealId}`), {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(savedState),
      });
      if (!saveResponse.ok) console.warn('⚠️ Besichtigung konnte nicht synchronisiert werden, Link wird trotzdem erstellt');
    }
  } catch (syncErr) {
    // Daten liegen evtl. schon auf dem Server – Link trotzdem erzeugen
    console.warn('Besichtigung vor Link-Erstellung nicht synchronisiert:', syncErr);
  }

  const response = await fetch(createApiUrl(`api/inspections/${dealId}/share`), {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
  });
  if (!response.ok) throw new Error('Fehler beim Generieren des Links');
  const data = await response.json();
  return data.url;
};
